export default "__VITE_ASSET__839IDnHM__";